
import Slider from 'react-infinite-logo-slider';

window.addEventListener('DOMContentLoaded', () => {
  const block = document.querySelector('#logos-slider');

  const speed = parseInt(block.getAttribute('data-speed'));
  const bgColor = block.getAttribute('data-bgcolor');
  const images = block.getAttribute('data-images');
  const imagesArray = JSON.parse(images);

  // Render the React slider component directly inside the block
  ReactDOM.render(
    <Slider
      width="200px"
      duration={speed}
      pauseOnHover={false}
      blurBorders={true}
      blurBoderColor={bgColor}
    >
      {imagesArray.map((image, index) => (
        <Slider.Slide key={index}>
          <div className="client-logos-slide">
            <img src={image.url} alt={image.alt} />
          </div>
        </Slider.Slide>
      ))}
    </Slider>,
    block
  );
});
